module.exports = __webpack_public_path__ + "img/mx_seguroportatil.f2aae25b.svg";